import React from "react";

const TextInput = React.forwardRef(
  (
    {
      id,
      label,
      placeholder,
      type = "text",
      className = "",
      labelClass = "",
      inputClass = "",
      error,
      register,
      placeholdertextcolor = "placeholder-[#B3D1E3]",
      ...props
    },
    ref
  ) => {
    return (
      <div key={id} className={`flex w-full flex-col gap-3 ${className}`}>
        {label && (
          <label htmlFor={id} className={`body-copy-small-text ${labelClass}`}>
            {label}
          </label>
        )}

        <input
          id={id}
          type={type}
          ref={ref}
          name={type}
          autoComplete={type}
          placeholder={placeholder}
          className={` text-20px-23px text-ff-purple  rounded-[21.5px] px-6 py-1 w-full outline-none border-none ${inputClass}`}
          {...register}
          {...props}
        />

        {error && <p className="text-red-500 text-xs">{error.message}</p>}
      </div>
    );
  }
);

TextInput.displayName = "TextInput";
export default TextInput;
